import InputCustom from 'components/Inputs'
import SimpleCard from 'components/SimpleCard'
import useRedux from 'hooks/useRedux'
import { useSelector } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { ApplicationState } from 'store'
import { CADASTRO_MODELO } from 'store/modules/backoffice/cadastroModelo/types'
import { CustomButton } from 'styles/global'
import InputVariable from 'components/Inputs/InputVariable'
import * as cadastroModelosActions from 'store/modules/backoffice/cadastroModelo/actions'
import { schema } from '../constants/schemas'
import { toast } from 'react-toastify'
import * as yup from 'yup'

export default function Register() {
  const { register, invalids, visualizacao } = useSelector<
    ApplicationState,
    CADASTRO_MODELO
  >((state) => state.cadastroModelo)

  const { dispatch } = useRedux()

  function cleanAllInvalids() {
    dispatch(cadastroModelosActions.cleanInvalids())
  }

  function onSave() {
    cleanAllInvalids()

    schema
      .validate(
        {
          id: register.id,
          descricao: register.descricao,
          atalho: register.atalho
        },
        { abortEarly: false }
      )
      .then(() => {
        if (register.id) {
          dispatch(
            cadastroModelosActions.atualizarModeloMensagemSaga(
              register,
              register.id
            )
          )
        } else {
          dispatch(cadastroModelosActions.criarModeloMensagemSaga(register))
        }
      })
      .catch((err) => {
        if (err.inner) {
          err.inner.forEach((e: yup.ValidationError) => {
            dispatch(
              cadastroModelosActions.setInvalids(
                true,
                e.path as keyof CADASTRO_MODELO['invalids']
              )
            )
          })
        }
        toast.warn(
          'Preencha todos os campos obrigatórios corretamente antes de salvar!'
        )
      })
  }

  function voltaParaSearch() {
    dispatch(cadastroModelosActions.cleanRegister())
    dispatch(cadastroModelosActions.cleanInvalids())
    dispatch(cadastroModelosActions.setVisualizacao(false))
    dispatch(cadastroModelosActions.setActiveTab('search'))
  }

  return (
    <SimpleCard>
      <Row className="mb-4">
        <Col md={6} className="d-flex">
          <CustomButton
            background="var(--roxo-riber)"
            letterSpacing={1}
            onClick={voltaParaSearch}
          >
            Voltar
          </CustomButton>
        </Col>
        {!visualizacao && (
          <Col md={6} className="d-flex justify-content-end">
            <CustomButton background="var(--verde-riber)" onClick={onSave}>
              Salvar
            </CustomButton>
          </Col>
        )}
      </Row>

      <Row className="mt-4">
        <label className="label-12 mb-2">Modelo*</label>
        <InputCustom
          type="text"
          placeholder="Digite aqui"
          value={register.atalho}
          onChange={(e) =>
            dispatch(
              cadastroModelosActions.setRegisterFields(e.target.value, 'atalho')
            )
          }
          invalid={invalids.atalho}
          disabled={visualizacao}
        />
      </Row>

      <Row className="mt-4">
        <label className="label-12 mb-2">Mensagem</label>
        <InputVariable
          className="inputField"
          rawValue={register.descricao}
          onRawChange={(value) => {
            if (value.length <= 300) {
              dispatch(
                cadastroModelosActions.setRegisterFields(value, 'descricao')
              )
            }
          }}
          placeholder="Digite aqui..."
          variables={[
            { descricao: 'nome Cliente', campoEquivalente: 'nome_cliente' },
            { descricao: 'nome Operador', campoEquivalente: 'nome_operador' },
            {
              descricao: 'valor da Oportunidade',
              campoEquivalente: 'valor_oportunidade'
            }
          ]}
          disabled={visualizacao}
        />
      </Row>
    </SimpleCard>
  )
}
